import Component from 'flarum/common/Component';
export default class SuggestionButton extends Component {
  view() {
    const attrs = this.attrs.attributes;
    const title = attrs.title;
    const url = attrs.url;
    const icon = attrs.icon;
    const onclick = attrs.onclick;
    return m("div", {
      style: url && `background-image: url(${url})`,
      onclick: onclick
    }, icon && m("i", {
      class: icon
    }), " ", title);
  }
}
flarum.reg.add('therealsujitk-gifs', 'forum/components/HomeButton', SuggestionButton);